import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page-wrapper full-height" }
const _hoisted_2 = { class: "page-wrapper__inner" }
const _hoisted_3 = { class: "controls" }
const _hoisted_4 = { class: "data-container" }
const _hoisted_5 = { class: "data-container__header hidden-lg" }
const _hoisted_6 = { class: "page-content" }
const _hoisted_7 = { class: "page-content__inner" }
const _hoisted_8 = { class: "hidden-lg" }
const _hoisted_9 = { class: "page-content-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabList = _resolveComponent("TabList")!
  const _component_BackLink = _resolveComponent("BackLink")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_NavList = _resolveComponent("NavList")!
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.navItems.length && _ctx.showTabList)
      ? (_openBlock(), _createBlock(_component_TabList, {
          key: 0,
          id: "page-mobile-nav",
          class: "hidden-lg",
          items: _ctx.navItems,
          activeItem: _ctx.activeItem
        }, null, 8, ["items", "activeItem"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "back", {}, () => [
          _createVNode(_component_BackLink, { url: "#" })
        ], true),
        _renderSlot(_ctx.$slots, "actionButton", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["page-details", _ctx.customDetailsClass])
        }, [
          _renderSlot(_ctx.$slots, "header", {}, undefined, true),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.$slots.title)
              ? _renderSlot(_ctx.$slots, "title", { key: 0 }, undefined, true)
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("h3", null, [
                    _createVNode(_component_TranslatedText, { path: _ctx.title }, null, 8, ["path"])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["subtitle", { 'has-avatar': _ctx.avatarData.image }])
                  }, [
                    _createVNode(_component_TranslatedText, { path: _ctx.subtitle }, null, 8, ["path"])
                  ], 2)
                ], 64))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["visible-lg", { 'display-side-footer-bottom': _ctx.displaySideFooterBottom }])
          }, [
            _createVNode(_component_NavList, {
              items: _ctx.navItems,
              activeItem: _ctx.activeItem,
              showIconRight: _ctx.showNavItemIconRight,
              showAvatar: _ctx.showNavItemAvatar,
              showSubtitle: _ctx.showNavItemSubtitle
            }, {
              default: _withCtx(({ item }) => [
                _renderSlot(_ctx.$slots, "navItem", { item: item }, undefined, true)
              ]),
              _: 3
            }, 8, ["items", "activeItem", "showIconRight", "showAvatar", "showSubtitle"]),
            _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
          ], 2)
        ], 2),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["page-header hidden-sm hidden-md", {
              ['hidden-lg']: _ctx.hideHeaderForLarge,
              ['visible-lg']: !_ctx.hideHeaderForLarge,
            }])
          }, [
            (_ctx.$slots.title)
              ? _renderSlot(_ctx.$slots, "title", { key: 0 }, undefined, true)
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.avatarData.image || _ctx.avatarData.text)
                    ? (_openBlock(), _createBlock(_component_Avatar, {
                        key: 0,
                        size: "md",
                        image: _ctx.avatarData.image,
                        alt: _ctx.avatarData.alt ? _ctx.avatarData.alt : '',
                        "aria-labelledby": _ctx.avatarData.aria ? _ctx.avatarData.aria : '',
                        text: _ctx.avatarData.text ? _ctx.avatarData.text : ''
                      }, null, 8, ["image", "alt", "aria-labelledby", "text"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("h3", null, [
                    _createVNode(_component_TranslatedText, { path: _ctx.title }, null, 8, ["path"])
                  ]),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "break" }, null, -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["subtitle", { 'has-avatar': _ctx.avatarData.image }])
                  }, [
                    _createVNode(_component_TranslatedText, { path: _ctx.subtitle }, null, 8, ["path"])
                  ], 2)
                ], 64))
          ], 2),
          _createElementVNode("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true),
            _createElementVNode("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _renderSlot(_ctx.$slots, "content-footer__buttons", {}, undefined, true)
          ])
        ])
      ])
    ])
  ]))
}